import React, { memo } from 'react';
import WebsiteFilters from 'components/filters/WebsiteFilters';

export const HomepageBlocksFilters = memo(
  ({
    onFiltersChange,
    shoppingCenters = [],
    loadingShoppingCenters = false,
    filters = {},
  }) => {
    return (
      <WebsiteFilters
        shoppingCenters={shoppingCenters}
        onFiltersChange={onFiltersChange}
        loading={loadingShoppingCenters}
        showInsegna={false}
        showCategorie={false}
        enableSorting={true}
        filters={filters}
      />
    );
  }
);

HomepageBlocksFilters.displayName = 'HomepageBlocksFilters';

export default HomepageBlocksFilters;

